import React from 'react';
import PropTypes from 'prop-types';
import {
  Wrapper,
  Block,
  StripOverlayRow,
  Title,
  SubTitle,
  Text,
  Phone,
  SocialMedia,
  Icon,
  Fb,
  Twitter,
  Tripadvisor,
  Instagram,
  MapsLink
} from './OpeningTimes.style';
import facebookIconUrl from '../../assets/icons/facebook.svg';
import twitterIconUrl from '../../assets/icons/twitter.svg';
import tripadvisorIconUrl from '../../assets/icons/tripadvisor.svg';
import instagramIconUrl from '../../assets/icons/instagram.svg';
import ExceptionalTimes from '../../components/ExceptionalTimes/ExceptionalTimes';

const OpeningTimes = props => {
  const {
    restaurant,
    firstColor,
    secondColor,
    backgroundImages,
    toggleFullTimes
  } = props;
  const {name, template, address, contactNumber} = restaurant;

  const renderAddressLine1 = address.buildingNumber
    ? `${address.buildingNumber} ${address.addressLine1}`
    : address.addressLine1;
  const renderOpeningTimes = template && template.light && template.light.openingTimes;
  const openingTimesLink = template && template.light && template.light.openingTimesLink;
  const renderSocialMedia = restaurant && restaurant.thirdPartyServices && (
    !!restaurant.thirdPartyServices.facebookPageUrl ||
    restaurant.thirdPartyServices.socialLinks && (
      !!restaurant.thirdPartyServices.socialLinks.Twitter ||
      !!restaurant.thirdPartyServices.socialLinks.Instagram ||
      !!restaurant.thirdPartyServices.socialLinks.TripAdvisor
    )
  ) && (
    <div>
      <Title>Follow Us</Title>
      <SocialMedia>
        {restaurant.thirdPartyServices.facebookPageUrl && (
          <Icon
            href={restaurant.thirdPartyServices.facebookPageUrl}
            target="_blank"
          >
            <Fb src={facebookIconUrl} />
          </Icon>
        )}
        {restaurant.thirdPartyServices.socialLinks && restaurant.thirdPartyServices.socialLinks.Twitter && (
          <Icon
            href={restaurant.thirdPartyServices.socialLinks.Twitter}
            target="_blank"
          >
            <Twitter src={twitterIconUrl} />
          </Icon>
        )}
        {restaurant.thirdPartyServices.socialLinks && restaurant.thirdPartyServices.socialLinks.Instagram && (
          <Icon
            href={restaurant.thirdPartyServices.socialLinks.Instagram}
            target="_blank"
          >
            <Instagram src={instagramIconUrl} />
          </Icon>
        )}
        {restaurant.thirdPartyServices.socialLinks && restaurant.thirdPartyServices.socialLinks.TripAdvisor && (
          <Icon
            href={restaurant.thirdPartyServices.socialLinks.TripAdvisor}
            target="_blank"
          >
            <Tripadvisor src={tripadvisorIconUrl} />
          </Icon>
        )}
      </SocialMedia>
    </div>
  );
  const renderExceptionalClosingTimes = restaurant && restaurant.exceptionalClosingTimes && restaurant.exceptionalClosingTimes.length > 0 &&
    <ExceptionalTimes
      restaurant={restaurant}
      opening={false}
    />;

  const renderExceptionalOpeningTimes = restaurant && restaurant.exceptionalOpeningTimes && restaurant.exceptionalOpeningTimes.length > 0 &&
    <ExceptionalTimes
      restaurant={restaurant}
      opening={true}
    />;
  const renderFullOpeningHours = openingTimesLink && (
    <SubTitle onClick={toggleFullTimes}>See our full opening hours</SubTitle>
  );
  const googleMapsUrl = (restaurant.thirdPartyServices && restaurant.thirdPartyServices.googleMapsUrl) ||
    `https://www.google.co.uk/maps/place/${restaurant.address.singleLine}`;

  return (
    <div className="backgroundImage">
      <Wrapper
        backgroundImages={backgroundImages}
        id="contactus"
        name="contactus"
      >
        <StripOverlayRow
          firstColor={firstColor}
          secondColor={secondColor}
        >
          <Block>
            <Title>{name}</Title>
            <MapsLink
              href={googleMapsUrl}
              target="_blank"
            >
              <Text>{renderAddressLine1}</Text>
              <Text>{address.addressLine2}</Text>
              <Text>{address.city}</Text>
              <Text>{address.postcode}</Text>
              <Text>(Open in Google Maps)</Text>
            </MapsLink>
            <Phone>{contactNumber}</Phone>
            {renderSocialMedia}
          </Block>
          <Block>
            <Title>Open Hours</Title>
            <Text>{renderOpeningTimes}</Text>
            {renderFullOpeningHours}
            {renderExceptionalClosingTimes}
            {renderExceptionalOpeningTimes}
          </Block>
        </StripOverlayRow>
      </Wrapper>
    </div>
  );
};

OpeningTimes.propTypes = {
  restaurant: PropTypes.object.isRequired,
  firstColor: PropTypes.string,
  secondColor: PropTypes.string,
  backgroundImages: PropTypes.object.isRequired,
  toggleFullTimes: PropTypes.func.isRequired
};

export default OpeningTimes;



// WEBPACK FOOTER //
// ./containers/LightHomePage/OpeningTimes.js